<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     排序选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dropdown trigger="hover" @command="selectChange">
    <div role="button" class="flex-center bg-white sort" :class="{ 'border': border }">
      <i class="iconfont icon-sort"></i>
      {{ placeholder }}
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="(item, index) in options" :key="index" :command="item.value" :class="{ 'text-primary': item.value == sortValue }">{{ item.title }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>

</template>

<script>

export default {
  name: "FSortSelector",

  props: {
    value: {
      type: Number,
      default: 0
    },

    placeholder: {
      type: String,
      default: '排序'
    },

    width: {
			type: String,
			default: '160'
		},

    border: {
			type: Boolean,
			default: false // 边框
		},

    options: {
      type: Array,
      default() {
        return []
      }
    },
  },

  data() {
    return {
    }
  },

  computed: {
    sortValue: {
      get() {
        return this.value ? this.value : 0
      },
      set(val) {
        this.$emit('input', val ? val : 0)
      }
    }
  },

  created() {
  },

  methods: {
    selectChange(val) {
      const list = this.options.map(v => v.value)
      const index = list.indexOf(val)
      const item = this.options[index]
      this.sortValue = val
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-popper[x-placement^="bottom"] {
  margin-top: 6px;
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}
.sort {
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  transition: all .2s;
  &.border {
    border: 1px solid #DCDFE6;
    &:hover {
      border: 1px solid #07c160;
    }
  }
  &:hover {
    background-color: #e6f9ef;
    color: #07c160;
  }
}
</style>
